import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IoClose, IoHeart } from 'react-icons/io5';
import Avatar from './Avatar';
import { postApi } from '../services/postApi';
import './LikeListModal.css';

const LikeListModal = ({ postId, onClose }) => {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadLikes();
  }, [postId]);

  const loadLikes = async () => {
    try {
      const response = await postApi.getPostLikes(postId);
      setUsers(response.data || []);
    } catch (error) {
      console.error('Error loading likes:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="like-list-modal-overlay" onClick={handleBackdropClick}>
      <div className="like-list-modal">
        <div className="like-list-header">
          <h3>
            <IoHeart className="like-list-icon" />
            {t('post.likes') || 'Likes'}
          </h3>
          <button className="like-list-close-btn" onClick={onClose}>
            <IoClose />
          </button>
        </div>

        <div className="like-list-content">
          {isLoading ? (
            <div className="like-list-loading">{t('common.loading') || 'Loading...'}</div>
          ) : users.length === 0 ? (
            <div className="like-list-empty">{t('post.noLikes') || 'No likes yet'}</div>
          ) : (
            <div className="like-list-users">
              {users.map((user) => (
                <Link
                  key={user.id}
                  to={`/profile/${user.id}`}
                  className="like-list-user"
                  onClick={onClose}
                >
                  <Avatar user={user} size="small" />
                  <div className="like-list-user-info">
                    <span className="like-list-user-name">{user.display_name}</span>
                    {user.bio && <span className="like-list-user-bio">{user.bio}</span>}
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LikeListModal;
